export function createDate(y, M = 0, d = 1, h = 0, m = 0, s = 0, ms = 0) {
    const date = new Date(y, M, d, h, m, s, ms);
    if (y < 100 && y >= 0) {
        date.setFullYear(y);
    }
    return date;
}

export function isValidDate(date) {
    return date instanceof Date && !isNaN(date);
  }